import { render, staticRenderFns } from "./offer_2023.vue?vue&type=template&id=e8af0406&scoped=true&"
import script from "./offer_2023.vue?vue&type=script&lang=js&"
export * from "./offer_2023.vue?vue&type=script&lang=js&"
import style0 from "./offer_2023.vue?vue&type=style&index=0&id=e8af0406&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8af0406",
  null
  
)

export default component.exports